import React, { useEffect, useState } from "react";
import MessageInfo from "./common/MessageInfo";
import MainContext from "./contexts/MainContext";
import { fetchOriginalPath } from "./data/seo/seoUtils";
import { concatUrlPathnames } from "./data/sport-utils";
import { getConfiguration, getEncodedURI } from "./data/utils";
import { appConfig } from "./InitData";
import { getLabel } from "./data/labels";

function RouteSeoPath(props) {
    const mainContext = React.useContext(MainContext);
    const [message,setMessage] = useState(null);

    useEffect(function() {
        if(getConfiguration().seo){
            console.log("no-matching for" +props.location.pathname)
            const pathname = concatUrlPathnames(appConfig.BASENAME,props.location.pathname);
            //console.log(pathname);
            //const originalPath = fetchOriginalPath(props.location.pathname);
            const originalPath = fetchOriginalPath(getEncodedURI(pathname));
            if(originalPath){
                mainContext.setSeoRoutePath(props.location.pathname,originalPath);
                setMessage('')
            }else{
                setMessage(getLabel('general.page_not_found', 'Page not found'))
            }
        }
       
    }, []);


    return (
        <>
        {message && 
        <MessageInfo message={message}/>
        }
        </>
    )
}

export default RouteSeoPath;